import type {IBannerData} from './IBannerData';

export class BannerDataNull implements IBannerData {
    static NULL: BannerDataNull = new BannerDataNull();
}
